<style lang="scss" scoped>
.video-block{
    padding: 0;
    background-color: #fff;
    height: 220px;
    border-radius: 34px;
    @media screen and (min-width: 767.98px) {
        width: 521px;
        height: 120px;
    }
}
.video-button-wrapper{
    border-radius: 34px 0 0 34px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position-x: center;
}
.video-content{
    border-radius: 0 34px 34px 0;
    width: 101%;
    @media screen and (min-width: 767.98px) {
        padding-left: 40px;
        padding-right: 40px;
    }
    .title{
        color: #fff;
        font-size: 20px;
        letter-spacing: 0;
        line-height: 25px;
    }
}
.cta{
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 21.7px;
}
.play-button {
    cursor: pointer;
    height: 40px;
    width: 40px;
    background-color: #FFF;
    border-radius: 50%;
    display: inline-block;
}

.play-button:before {
    position: absolute;
    content: "";
    transform: translateY(-50%);
    margin: 20px 16px;
    background-image: url("/svg/play.svg");
    background-size: contain;
    background-repeat: no-repeat;
    width: 14px;
    height: 14px;
    transition: all 0.3s;
    opacity: 1;
}

.play-button:hover:before {
    margin: 19px 16px;
    width: 18px;
    height: 18px;
}
.cta:hover{
    cursor: pointer;
}
</style>

<template>
    <section class="container grid grid-cols-12 video-block">
        <div class="col-span-5 lg:col-span-4 video-button-wrapper
        flex flex-col justify-center items-center" :style="thumbnailImage">
            <span v-if="videoId != null && videoId != ''" @click="showVideo = !showVideo" class="play-button"></span>
        </div>
        <div class="col-span-7 lg:col-span-8 video-content bg-dark-blue
        flex flex-col justify-center items-center lg:items-start">
            <p class="title text-white">{{ title }}</p>
            <a class="cta text-yellow pt-8 hover:text-blue" @click="showVideo = !showVideo">{{ cta }}</a>
            <portal to="video-modal-destination">
                <video-modal :video-id="videoId" :open="showVideo" @close="close"></video-modal>
            </portal>
        </div>
    </section>
</template>

<script>
import VideoModal from "./VideoModal";
export default {
    components: {VideoModal},
    props: {
        thumbnail:{
            required: true
        },
        videoId:{
            required: true
        },
        title:{
            required: true
        },
        cta:{
            required: true
        }
    },
    data() {
        return {
            showVideo: false,
        };
    },

    methods: {
        close() {
            this.showVideo = false;
        },
    },
    mounted() {

        if (document.getElementById("player") != null) {
            const player = new Plyr("#player", {
                volume: 1,
                autoplay: false,
                hideControls: true,
                controls: ['play-large']
            });

            player.toggleControls(false);
            player.play();
            if (this.image) player.poster = this.image;

            player.on("play", (any) => {
                player.toggleControls(true);
            });

        }
    },
    computed: {
        thumbnailImage() {
            return "background-image: url(" + this.thumbnail + ');'
        }
    }
}
</script>
